export default __webpack_public_path__ + "static/media/Dash.390d1c0b.svg";